import styled from 'styled-components';
import { Switch } from 'antd';

export const PageWrapper = styled.div`
  padding: 0;
`;

export const TableWrapper = styled.div`
  margin-top: 16px;
`;

export const NameText = styled.span`
  font-weight: 600;
`;

export const DescriptionText = styled.span`
  color: #888;
  font-size: 13px;
`;

export const SoldOutSwitchWrap = styled.div<{ $busy: boolean }>`
  display: inline-block;
  cursor: ${({ $busy }) => ($busy ? 'not-allowed' : 'pointer')};
`;

export const SoldOutSwitch = styled(Switch).withConfig({
  shouldForwardProp: (prop) => prop !== '$soldOut',
})<{ $soldOut?: boolean }>`
  ${({ $soldOut }) => $soldOut && 'background: #ff4d4f !important;'}

  .ant-switch-inner .ant-switch-inner-checked,
  .ant-switch-inner .ant-switch-inner-unchecked {
    color: #fff !important;
  }
`;
